// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── FilterDropdown ─────────────────────────────────────────────────────── */

.filter-v3-wrapper {
  position: relative;
  display: inline-block;
}

/* ── Trigger button ─────────────────────────────────────────────────────── */

.filter-v3-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: box-shadow 0.15s ease;
  justify-content: space-between;
}

.filter-v3-button:hover {
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.13) !important;
}

/* Icon position variants */
.filter-v3-button--icon-left {
  flex-direction: row-reverse;
}
.filter-v3-button--icon-right {
  flex-direction: row;
}

/* ── Button label ───────────────────────────────────────────────────────── */

.filter-v3-button-label {
  white-space: nowrap;
}

/* ── Chevron icon wrapper ───────────────────────────────────────────────── */

.filter-v3-icon {
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
}

.filter-v3--open {
  transform: rotate(180deg);
}

/* ── Count badge ────────────────────────────────────────────────────────── */

.filter-v3-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-weight: 700;
  line-height: 1;
  padding: 0 4px;
}

/* Badge position variants */
.filter-v3-badge--top-right {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-v3-badge--top-left {
  position: absolute;
  top: -8px;
  left: -8px;
}
.filter-v3-badge--inline-right {
  position: static;
  margin-left: 6px;
}
.filter-v3-badge--inline-left {
  position: static;
  margin-right: 6px;
}

/* ── Dropdown panel ─────────────────────────────────────────────────────── */

.filter-v3-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  min-width: 200px;
  border: 1.5px solid #e5e7ef;
  padding: 10px 6px;
  z-index: 9999;
  animation: filter-v3-fade-in 0.15s ease;
}

.filter-v3-dropdown--left {
  left: 0;
  right: auto;
}

.filter-v3-dropdown--right {
  right: 0;
  left: auto;
}

/* ── Options list (scrolls internally when dropdownMaxHeight is set) ───────── */

.filter-v3-options-list {
  display: flex;
  flex-direction: column;
}

/* Styled scrollbar — only applied when the list is actually scrollable
   (dropdownMaxHeight set), so other PosCustomFilterV3 usages are untouched. */
.filter-v3-options-list--scrollable {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f8fafc;
}

.filter-v3-options-list--scrollable::-webkit-scrollbar {
  width: 6px;
}

.filter-v3-options-list--scrollable::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 3px;
}

.filter-v3-options-list--scrollable::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.filter-v3-options-list--scrollable::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@keyframes filter-v3-fade-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Option row ─────────────────────────────────────────────────────────── */

.filter-v3-option {
  display: flex;
  align-items: center;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  background: transparent;
  transition: background 0.13s ease;
  user-select: none;
}

.filter-v3-option:hover {
  background: #f0f4ff;
}

/* Checkbox position variants */
.filter-v3-option--checkbox-left {
  flex-direction: row;
  justify-content: flex-start;
}
.filter-v3-option--checkbox-right {
  flex-direction: row-reverse;
  justify-content: space-between;
}

/* ── Checkbox ───────────────────────────────────────────────────────────── */

.filter-v3-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
}

/* ── Option label ───────────────────────────────────────────────────────── */

.filter-v3-option-text {
  flex: 1;
}

/* ── Dark theme ── */
.dark .filter-v3-dropdown {
  background: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .filter-v3-option:hover {
  background: #334155;
}

.dark .filter-v3-option-text {
  color: #f1f5f9;
}

.dark .filter-v3-options-list--scrollable {
  scrollbar-color: #475569 #1e293b;
}

.dark .filter-v3-options-list--scrollable::-webkit-scrollbar-track {
  background: #1e293b;
}

.dark .filter-v3-options-list--scrollable::-webkit-scrollbar-thumb {
  background: #475569;
}

.dark .filter-v3-options-list--scrollable::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomFilterV3/PosCustomFilterV3.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;8EAC8E;AAC9E;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;;2BAEyB;AAC3B;;AAEA,8EAA8E;;AAE9E;EACE,OAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ── FilterDropdown ─────────────────────────────────────────────────────── */\n\n.filter-v3-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n/* ── Trigger button ─────────────────────────────────────────────────────── */\n\n.filter-v3-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  position: relative;\n  outline: none;\n  transition: box-shadow 0.15s ease;\n  justify-content: space-between;\n}\n\n.filter-v3-button:hover {\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.13) !important;\n}\n\n/* Icon position variants */\n.filter-v3-button--icon-left {\n  flex-direction: row-reverse;\n}\n.filter-v3-button--icon-right {\n  flex-direction: row;\n}\n\n/* ── Button label ───────────────────────────────────────────────────────── */\n\n.filter-v3-button-label {\n  white-space: nowrap;\n}\n\n/* ── Chevron icon wrapper ───────────────────────────────────────────────── */\n\n.filter-v3-icon {\n  display: inline-flex;\n  align-items: center;\n  transition: transform 0.2s ease;\n}\n\n.filter-v3--open {\n  transform: rotate(180deg);\n}\n\n/* ── Count badge ────────────────────────────────────────────────────────── */\n\n.filter-v3-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 0 4px;\n}\n\n/* Badge position variants */\n.filter-v3-badge--top-right {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n}\n.filter-v3-badge--top-left {\n  position: absolute;\n  top: -8px;\n  left: -8px;\n}\n.filter-v3-badge--inline-right {\n  position: static;\n  margin-left: 6px;\n}\n.filter-v3-badge--inline-left {\n  position: static;\n  margin-right: 6px;\n}\n\n/* ── Dropdown panel ─────────────────────────────────────────────────────── */\n\n.filter-v3-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  min-width: 200px;\n  border: 1.5px solid #e5e7ef;\n  padding: 10px 6px;\n  z-index: 9999;\n  animation: filter-v3-fade-in 0.15s ease;\n}\n\n.filter-v3-dropdown--left {\n  left: 0;\n  right: auto;\n}\n\n.filter-v3-dropdown--right {\n  right: 0;\n  left: auto;\n}\n\n/* ── Options list (scrolls internally when dropdownMaxHeight is set) ───────── */\n\n.filter-v3-options-list {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Styled scrollbar — only applied when the list is actually scrollable\n   (dropdownMaxHeight set), so other PosCustomFilterV3 usages are untouched. */\n.filter-v3-options-list--scrollable {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 #f8fafc;\n}\n\n.filter-v3-options-list--scrollable::-webkit-scrollbar {\n  width: 6px;\n}\n\n.filter-v3-options-list--scrollable::-webkit-scrollbar-track {\n  background: #f8fafc;\n  border-radius: 3px;\n}\n\n.filter-v3-options-list--scrollable::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.filter-v3-options-list--scrollable::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n@keyframes filter-v3-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ── Option row ─────────────────────────────────────────────────────────── */\n\n.filter-v3-option {\n  display: flex;\n  align-items: center;\n  padding: 9px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  background: transparent;\n  transition: background 0.13s ease;\n  user-select: none;\n}\n\n.filter-v3-option:hover {\n  background: #f0f4ff;\n}\n\n/* Checkbox position variants */\n.filter-v3-option--checkbox-left {\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.filter-v3-option--checkbox-right {\n  flex-direction: row-reverse;\n  justify-content: space-between;\n}\n\n/* ── Checkbox ───────────────────────────────────────────────────────────── */\n\n.filter-v3-checkbox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border: 2px solid;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n/* ── Option label ───────────────────────────────────────────────────────── */\n\n.filter-v3-option-text {\n  flex: 1;\n}\n\n/* ── Dark theme ── */\n.dark .filter-v3-dropdown {\n  background: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .filter-v3-option:hover {\n  background: #334155;\n}\n\n.dark .filter-v3-option-text {\n  color: #f1f5f9;\n}\n\n.dark .filter-v3-options-list--scrollable {\n  scrollbar-color: #475569 #1e293b;\n}\n\n.dark .filter-v3-options-list--scrollable::-webkit-scrollbar-track {\n  background: #1e293b;\n}\n\n.dark .filter-v3-options-list--scrollable::-webkit-scrollbar-thumb {\n  background: #475569;\n}\n\n.dark .filter-v3-options-list--scrollable::-webkit-scrollbar-thumb:hover {\n  background: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
